import { useEffect, useState } from 'react';
import databaseMonitorService, { InnoDbStatus } from '../../../../../services/databaseMonitor.service';

export function InnoDbView({ serverId }: { serverId: string }) {
  const [data, setData] = useState<InnoDbStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(null);
    setData(null);
    databaseMonitorService
      .getInnoDb(serverId, controller.signal)
      .then((d) => {
        setData(d);
        setLoading(false);
      })
      .catch((err: any) => {
        if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') return;
        setError(err?.response?.data?.detail ?? err?.message ?? 'Failed to load InnoDB status');
        setLoading(false);
      });
    return () => controller.abort();
  }, [serverId]);

  if (loading) return <div className="text-slate-600 dark:text-slate-400">Loading…</div>;
  if (error) return <div className="text-red-600 dark:text-red-400">Error: {error}</div>;
  const raw = data?.raw ?? '';

  return (
    <pre className="bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-md p-3 text-xs whitespace-pre-wrap max-h-[70vh] overflow-auto text-slate-900 dark:text-slate-100">
      {raw || '(empty)'}
    </pre>
  );
}

export default InnoDbView;
